import { appPath } from '@web3/base-utils';

import styles from './index.module.scss';
import iconBars from '@/assets/icon/icon-bars.gif';

type IconType = 'smile' | 'countdown' | 'bars';

export interface TagProps {
  icon: IconType;
  text: string;
}

export const Tag = ({ icon, text }: TagProps) => {
  const iconUrlMap: Record<IconType, string> = {
    smile:
      'https://s1.bycsi.com/bybit/deadpool/image-2c1300fcb79f4fdc9c1aa5ffa9d4527a.svg',
    countdown:
      'https://s1.bycsi.com/bybit/deadpool/image-ae52b4a27ff14d4cb97b6bac9fc7abf7.svg',
  };

  return (
    <div className={styles.tag}>
      {icon === 'bars' && (
        <img
          src={`${appPath}/gif/icon-bars.gif`}
          className={styles.icon}
          alt="bars"
        />
      )}
      {icon !== 'bars' && (
        <img className={styles.icon} alt={icon} src={iconUrlMap[icon]} />
      )}
      <div className={styles.text}>{text}</div>
    </div>
  );
};

export default Tag;
